var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-badge-container",class:{ warning: _vm.warning, error: _vm.error, info: _vm.info, small: _vm.small }},[_c('Icon',{attrs:{"name":"info-circle"}}),_c('span',[_vm._v(_vm._s(_vm.msg))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }